<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="src && !backgroundMode && true">
    <img [src]="src" [ngStyle]="imageStyles" />
  </ng-container>
  <ng-container *ngSwitchCase="src && backgroundMode && true">
    <div
      class="image-container"
      [ngStyle]="imageStyles"
      [style.background-image]="'url(' + src + ')'"
    ></div>
  </ng-container>
  <ng-container *ngSwitchCase="!src && fullName && true">
    <div
      #avatarPlaceholder
      class="avatar-placeholder"
      [class.backend]="backendStyleInitials"
      [class.colorized]="colorized"
      [class.has-color-background]="hasColorBackground"
    >
      <div class="initials">{{ nameInitials }}</div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="!src && iconName && true">
    <div class="avatar-icon" [class.light]="iconIsLight">
      <rt-icon [name]="iconName" [isLight]="iconIsLight"></rt-icon>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="avatarTpl"></ng-container>
  </ng-container>
</ng-container>

<div *ngIf="online" class="online-indicator"></div>

<div *ngIf="hasUnreadNotifications" class="has-notifications">
  <ng-container *ngTemplateOutlet="tooltipTplRef"></ng-container>
</div>
